export enum HeyDriveStorageIncreaseReason {
  PURCHASE = 'purchase',
  COUPON_USAGE = 'coupon',
  PRE_ORDER = 'pre_order',
  OTHER = 'other',
}
export default interface HeyDriveStorageIncreaseNote {
  id: string
  created_at: string
  reason: HeyDriveStorageIncreaseReason
  more_months: number
  more_days: number
  applied: boolean
}
